var map = {
	"./british-woman-jailed.png": "G77W",
	"./bullet-background.png": "rX6n",
	"./careers-article.png": "Wmjk",
	"./cesar.png": "YfIE",
	"./chafik.jpg": "qmZ4",
	"./cholera.png": "v5JP",
	"./covid.jpg": "zpdN",
	"./cqc-clinics.png": "9uB0",
	"./debbie.png": "nOV/",
	"./dermot.png": "9Wrf",
	"./diptheria.png": "N240",
	"./eastleigh.png": "sBY9",
	"./eduardo.png": "o3q6",
	"./hepatitis-a.png": "YDrX",
	"./hepatitis-b.png": "98VT",
	"./hero-banner/404.png": "xL5H",
	"./hero-banner/affiliate-header.jpg": "/TeS",
	"./hero-banner/airport.jpeg": "+8DC",
	"./hero-banner/careers.png": "Ggxa",
	"./hero-banner/contact-us.png": "6245",
	"./hero-banner/faq-banner.png": "FBLA",
	"./hero-banner/hdw-header-img.png": "trUF",
	"./hero-banner/lady-with-bag.jpg": "QSHg",
	"./hero-banner/meeting.jpg": "lVes",
	"./hero-banner/packages-cover.png": "UZ1Z",
	"./hero-banner/privacy.jpg": "YY1l",
	"./hero-banner/selfie-photo.png": "X+Ep",
	"./hero-banner/swab-test.jpg": "hfSN",
	"./hero-banner/tagline-img.png": "iX65",
	"./hero-banner/terms-and-conds.jpg": "+PG4",
	"./hero-banner/travel-vaccination.png": "utVX",
	"./hero-banner/workplace.jpg": "X2hf",
	"./infographic.jpg": "tlSo",
	"./japanese-encephalitis.png": "S+FV",
	"./jw.jpg": "nR3F",
	"./lady-getting-vaccine.jpg": "HRXc",
	"./madhur.jpg": "66NA",
	"./meningitis-a.png": "Em27",
	"./meningitis-b.png": "kB/p",
	"./mission.jpg": "Rxs1",
	"./mmr.png": "t4++",
	"./mosquito.png": "DnJv",
	"./nationwide-pathology.jpeg": "oLZu",
	"./patricia.png": "pqxu",
	"./ph.png": "BmBy",
	"./phil.png": "4mcI",
	"./polio.png": "YIIr",
	"./rabies.png": "kmZu",
	"./register.png": "uRBB",
	"./roman.png": "4NZd",
	"./sea-nature-beach-sand.png": "8zbH",
	"./sophia.png": "nzTq",
	"./sridhar.png": "Tq7e",
	"./tb.png": "wk3s",
	"./tbe.png": "cl6j",
	"./tetanus.png": "6ahJ",
	"./typhoid.png": "GSLB",
	"./vision.jpg": "jcND",
	"./wellness-seminar.png": "7/rO",
	"./yellow-fever.png": "MD1K"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "dYTa";